import { instance } from "libs/api";

import { Category } from "../../categories.types";
import { ApiRoutesCategories } from "./../../constants";
import { UpdateSubChildCategoryPayload } from "./updateSubChildCategory.types";

export const requestUpdateSubChildCategory = async (
  body: UpdateSubChildCategoryPayload
): Promise<Category> => {
  return await instance.put(ApiRoutesCategories.SubChildCategory, body);
};
